import { Routes } from '@angular/router';
//Layouts
import {
  // CondensedComponent,
  // BlankComponent,
  // CorporateLayout,
  SimplyWhiteLayout,
  // ExecutiveLayout,
  // CasualLayout,
  // BlankCasualComponent,
  // BlankCorporateComponent,
  BlankSimplywhiteComponent,
  // DemoComponent
} from './@pages/layouts';

//Sample Pages
// import { CondensedDashboardComponent } from './dashboard/condensed/dashboard.component';
import { SimplyWhiteDashboardComponent } from './dashboard/simplywhite/dashboard.component';
// import { CasualDashboardComponent } from './dashboard/casual/dashboard.component';
// import { CorporateDashboardComponent } from './dashboard/corporate/dashboard.component';
// import { ExecutiveDashboardComponent } from './dashboard/executive/dashboard.component';
import { CardsPageComponent } from './cards/cards.component';
import { ViewsPageComponent } from './views/views.component';
// import { ChartsComponent } from './charts/charts.component';
// import { SocialComponent } from './social/social.component';
import { AuthGuard } from './_guards/auth.guard';
import { AuthChildGuard } from './_guards/authChild.guard';

export const AppRoutes: Routes = [
  {
    path: '',
    data: {
      breadcrumb: 'Home',
    },
    component: SimplyWhiteLayout,
    canActivate: [AuthGuard],
    canActivateChild: [AuthChildGuard],
    children: [
      {
        path: '',
        redirectTo: '/deals/list', pathMatch: 'full',
      },
      {
        path: 'contacts',
        loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsModule),
      },
      {
        path: 'deals',
        loadChildren: () => import('./deals/deals.module').then(m => m.DealsModule),
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
      },
      {
        path: 'inventory',
        loadChildren: () => import('./inventory/inventory.module').then(m => m.InventoryModule),
      },
      {
        path: 'calendar',
        loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarModule),
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
      },
    ],
  },
  {
    path: 'session',
    component: BlankSimplywhiteComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./session/session.module').then(m => m.SessionModule),
      },
    ],
  },
  {
    path: 'print',
    component: BlankSimplywhiteComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./print/print.module').then(m => m.PrintModule),
  },
  

  //Simply White Routes
  {
    path: 'simplywhite',
    component: SimplyWhiteLayout,
    children: [
      {
        path: 'dashboard',
        component: SimplyWhiteDashboardComponent,
      },
    ],
  },
  {
    path: 'simplywhite',
    component: SimplyWhiteLayout,
    children: [
      {
        path: 'extra',
        loadChildren: () => import('./extra/extra.module').then(m => m.ExtraModule),
      },
    ],
  },
  {
    path: 'simplywhite',
    component: BlankSimplywhiteComponent,
    children: [
      {
        path: 'session',
        loadChildren: () => import('./session/session.module').then(m => m.SessionModule),
      },
    ],
  },
  // {
  //   path: 'simplywhite',
  //   component: SimplyWhiteLayout,
  //   children: [
  //     {
  //       path: 'social',
  //       component: SocialComponent
  //     }
  //   ]
  // },
  {
    path: 'simplywhite',
    component: SimplyWhiteLayout,
    children: [
      {
        path: 'forms',
        loadChildren: () => import('./forms/forms.module').then(m => m.FormsPageModule),
      },
      {
        path: 'layouts',
        loadChildren: () => import('./layouts/layouts.module').then(m => m.LayoutPageModule),
      },
      {
        path: 'builder',
        loadChildren: () => import('./builder/builder.module').then(m => m.BuilderModule),
      },
      {
        path: 'ui',
        loadChildren: () => import('./ui/ui.module').then(m => m.UiModule),
      },
      {
        path: 'email',
        loadChildren: () => import('./email-light/email.module').then(m => m.EmailLightModule),
      },
      {
        path: 'cards',
        component: CardsPageComponent,
      },
      {
        path: 'views',
        component: ViewsPageComponent,
      },
      {
        path: 'tables',
        loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule),
      },
      {
        path: 'maps',
        loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule),
      },
    ],
  },
  // {
  //   path: 'simplywhite',
  //   component: SimplyWhiteLayout,
  //   children: [
  //     {
  //       path: 'charts',
  //       component: ChartsComponent
  //     }
  //   ]
  // },


  //Executive
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: ExecutiveDashboardComponent,
  //       data: {
  //         title: 'dashboard'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'social',
  //       component: SocialComponent,
  //       data: {
  //         title: 'social'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'extra',
  //       loadChildren: () => import('./extra/extra.module').then(m => m.ExtraModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'layouts',
  //       loadChildren: () => import('./layouts/layouts.module').then(m => m.LayoutPageModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'builder',
  //       loadChildren: () => import('./builder/builder.module').then(m => m.BuilderModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: BlankComponent,
  //   children: [
  //     {
  //       path: 'session',
  //       loadChildren: () => import('./session/session.module').then(m => m.SessionModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'forms',
  //       loadChildren: () => import('./forms/forms.module').then(m => m.FormsPageModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'ui',
  //       loadChildren: () => import('./ui/ui.module').then(m => m.UiModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'email',
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'cards',
  //       component: CardsComponentPage,
  //       data: {
  //         title: 'cards'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'views',
  //       component: ViewsPageComponent,
  //       data: {
  //         title: 'views'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'tables',
  //       loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'maps',
  //       loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule),
  //       data: {
  //         title: 'maps'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: 'executive',
  //   component: ExecutiveLayout,
  //   children: [
  //     {
  //       path: 'charts',
  //       component: ChartsComponent,
  //       data: {
  //         title: 'charts'
  //       }
  //     }
  //   ]
  // },
  // //Casual
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: CasualDashboardComponent
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'social',
  //       component: SocialComponent
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'builder',
  //       loadChildren: () => import('./builder/builder.module').then(m => m.BuilderModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'layouts',
  //       loadChildren: () => import('./layouts/layouts.module').then(m => m.LayoutPageModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'extra',
  //       loadChildren: () => import('./extra/extra.module').then(m => m.ExtraModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: BlankCasualComponent,
  //   children: [
  //     {
  //       path: 'session',
  //       loadChildren: () => import('./session/session.module').then(m => m.SessionModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'forms',
  //       loadChildren: () => import('./forms/forms.module').then(m => m.FormsPageModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'ui',
  //       loadChildren: () => import('./ui/ui.module').then(m => m.UiModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'email',
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'cards',
  //       component: CardsComponentPage
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'views',
  //       component: ViewsPageComponent
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'tables',
  //       loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'maps',
  //       loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule)
  //     }
  //   ]
  // },
  // {
  //   path: 'casual',
  //   component: CasualLayout,
  //   children: [
  //     {
  //       path: 'charts',
  //       component: ChartsComponent
  //     }
  //   ]
  // }
];
